import { DEFAULT_PATHS } from './ApiUtils';
import { CATEGORIES } from './PermissionsChecker';

export const COMMERCIAL_CONTROLS_TABS = [
  { key: 'agencies', label: 'Agencies', category: CATEGORIES.AGENCIES },
  { key: 'agency-groups', label: 'Agency Groups', category: CATEGORIES.AGENCIES_GROUPS },
  { key: 'brands', label: 'Brands', category: CATEGORIES.BRANDS },
  { key: 'markets', label: 'Markets', category: CATEGORIES.MARKETS },
  { key: 'distribution-channels', label: 'Distribution Channels', category: CATEGORIES.DISTRIBUTION_CHANNELS },
];

export const getCommercialControlsTabPath = (key: string) =>
  `/${DEFAULT_PATHS.BUSINESS_DATA}/${DEFAULT_PATHS.COMMERCIAL_CONTROLS}/${key}`;
